const ESTADOS_NEO_ALTA = [
  {
    id: 0,
    name: 'Puesta a disposición'
  },
  {
    id: 2,
    name: 'Descargada'
  },
  {
    id: 13,
    name: 'Descarga externa'
  }
]

export {
  ESTADOS_NEO_ALTA
}
